import { getTenantSessionScope } from '../api/api1';

let cache = {
  seats: null,
  rooms: null,
  libraries: null,
  ts: 0,
  scope: '',
};

const TTL = 5 * 60 * 1000;

const getScopedCache = () => {
  const scope = getTenantSessionScope();
  if (cache.scope !== scope) {
    cache = { seats: null, rooms: null, libraries: null, ts: 0, scope };
  }
  return cache;
};

export const getSeatsCache = () => getScopedCache();

export const setSeatsCache = (data = {}, expectedScope = getTenantSessionScope()) => {
  if (expectedScope !== getTenantSessionScope()) return getScopedCache();
  const currentCache = getScopedCache();
  cache = {
    seats: data.seats || currentCache.seats || [],
    rooms: data.rooms || currentCache.rooms || [],
    libraries: data.libraries || currentCache.libraries || [],
    ts: Date.now(),
    scope: currentCache.scope,
  };
  return cache;
};

export const isSeatsCacheFresh = () => {
  return Boolean(cache.seats && cache.seats.length && Date.now() - cache.ts < TTL);
};

export const clearSeatsCache = () => {
  cache = { seats: null, rooms: null, libraries: null, ts: 0, scope: getTenantSessionScope() };
};
